// Branded post-payment confirmation page — Stripe Payment Link redirects here on success.
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Mail } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useEffect } from "react";
import { track } from "@/lib/tracker";

export default function RegistrationConfirmed() {
  useEffect(() => { track("checkout_complete", { page: "registration_confirmed" }); }, []);

  return (
    <div data-testid="registration-confirmed-page" className="bg-white min-h-screen flex flex-col text-ink">
      <Header />
      <main className="flex-1 grid place-items-center px-6 pt-32 pb-20">
        <div className="max-w-2xl w-full text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-soft border border-brand/20 mb-8">
            <CheckCircle2 className="text-brand" size={28} />
          </div>
          <div className="font-mono-spec text-[11px] uppercase tracking-[0.22em] text-brand mb-3 font-medium">Payment Submitted</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-[-0.035em] text-ink leading-[1.05]">
            Thank you! Your payment has been{" "}
            <span className="font-serif-em italic text-brand font-light">submitted</span>{" "}
            through Stripe.
          </h1>
          <p className="mt-7 text-lg text-ink/75 leading-relaxed">
            Please check your email for your <strong className="text-ink">official Stripe receipt</strong> and additional program details.
          </p>

          <div className="mt-10 p-6 rounded-2xl bg-bone border border-[var(--line)] text-left flex gap-4 items-start">
            <Mail size={20} className="text-brand mt-1 shrink-0" />
            <div>
              <div className="text-ink font-semibold">What happens next</div>
              <ul className="text-sm text-ink/70 mt-2 space-y-1.5 list-disc pl-4">
                <li>Stripe will email your receipt directly.</li>
                <li>We verify the payment manually and confirm your seat by email.</li>
                <li>Your Zoom registration link will arrive before the live build lab on <strong className="text-ink">June 23, 2026 at 7:00 PM EST</strong>.</li>
              </ul>
            </div>
          </div>

          <p className="mt-6 text-xs text-ink/55 max-w-md mx-auto leading-relaxed">
            Questions? Write to <a href="mailto:info@itsthefreedominme.com" className="text-brand underline">info@itsthefreedominme.com</a>.
          </p>

          <div className="mt-10">
            <Link to="/" data-testid="confirmed-home-link">
              <Button variant="outline" className="btn-outline-ink rounded-full h-12 px-6 font-medium">
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
